/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListAnnouncement } from '../../models/api-response-list-announcement';

export interface Bootstrap$Params {
}

export function bootstrap(http: HttpClient, rootUrl: string, params?: Bootstrap$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAnnouncement>> {
  const rb = new RequestBuilder(rootUrl, bootstrap.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListAnnouncement>;
    })
  );
}

bootstrap.PATH = '/v1/api/announcement-client/bootstrap';
